import React, { Fragment, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import { ledgerList, ledgerReport } from "../../../services/accounts";
import { exportPDF, exportExcel } from "./exportUtils";

export default function LedgerReport() {
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const [ledger, setLedger]               = useState("");
  const [fromDate, setFromDate]           = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [toDate, setToDate]               = useState(moment().format("YYYY-MM-DD"));
  const [data, setData]                   = useState(null);
  const [loading, setLoading]             = useState(false);
  const [errorMessage, setErrorMessage]   = useState("");

  useEffect(() => {
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1") {
      temp.append("academy_id", localStorage.getItem("AAcademy") || "");
    }
    ledgerList(temp).then((res) => {
      if (res?.status) setLedgerOptions(res.data.map((l) => ({ value: l.id, label: l.ledger_name })));
    });
  }, []);

  function handleSearch() {
    setErrorMessage(""); setData(null);
    if (!ledger) { setErrorMessage("Please select a ledger"); return; }
    setLoading(true);
    const temp = new FormData();
    temp.append("ledger_id", ledger.value);
    temp.append("from_date", fromDate);
    temp.append("to_date", toDate);
    if (localStorage.getItem("Role") === "1") {
      temp.append("academy_id", localStorage.getItem("AAcademy") || "");
    }
    ledgerReport(temp).then((res) => {
      setLoading(false);
      if (res?.status) setData(res.data);
      else setErrorMessage(res?.message || "Error fetching report");
    });
  }

  let runningBalance = data ? (data.opening_type === "Dr" ? data.opening_balance : -data.opening_balance) : 0;

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Ledger Report</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Accounts</a></li>
            <li className="breadcrumb-item active" aria-current="page">Ledger Report</li>
          </ol>
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <Row className="row-sm mx-0">
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">Ledger <span className="text-danger"> *</span></label>
                    <Select
                      className="default-select"
                      placeholder="Select Ledger"
                      options={ledgerOptions}
                      value={ledger}
                      onChange={(e) => setLedger(e)}
                      isClearable
                    />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">From Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">To Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <a onClick={handleSearch} className="btn btn-success">
                      {loading ? "Loading..." : "Show"}
                    </a>
                  </div>
                </Col>
              </Row>
              {errorMessage && <span className="text-danger">{errorMessage}</span>}
            </div>
          </div>

          {data && (
            <div className="card custom-card mg-b-20">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <strong>{data.ledger?.ledger_name}</strong> — {data.from_date} to {data.to_date}
                    &nbsp;|&nbsp; Opening: <strong>{parseFloat(data.opening_balance).toFixed(2)} {data.opening_type}</strong>
                  </div>
                  <div>
                    <a onClick={() => {
                      const cols = ["Date", "Voucher No", "Type", "Narration", "Debit", "Credit", "Balance"];
                      let running = data.opening_type === "Dr" ? data.opening_balance : -data.opening_balance;
                      const rows = (data.transactions || []).map((tx) => {
                        running += (parseFloat(tx.debit_amount) || 0) - (parseFloat(tx.credit_amount) || 0);
                        return [tx.voucher_date, tx.voucher_no, tx.voucher_type, tx.narration || "",
                          parseFloat(tx.debit_amount) > 0  ? parseFloat(tx.debit_amount).toFixed(2)  : "",
                          parseFloat(tx.credit_amount) > 0 ? parseFloat(tx.credit_amount).toFixed(2) : "",
                          `${Math.abs(running).toFixed(2)} ${running >= 0 ? "Dr" : "Cr"}`];
                      });
                      exportPDF(`Ledger - ${data.ledger?.ledger_name}`, cols, rows);
                    }} className="btn btn-danger btn-sm me-2">
                      <i className="fa fa-file-pdf-o me-1" /> PDF
                    </a>
                    <a onClick={() => {
                      const cols = ["Date", "Voucher No", "Type", "Narration", "Debit", "Credit", "Balance"];
                      let running = data.opening_type === "Dr" ? data.opening_balance : -data.opening_balance;
                      const rows = (data.transactions || []).map((tx) => {
                        running += (parseFloat(tx.debit_amount) || 0) - (parseFloat(tx.credit_amount) || 0);
                        return [tx.voucher_date, tx.voucher_no, tx.voucher_type, tx.narration || "",
                          parseFloat(tx.debit_amount) > 0  ? parseFloat(tx.debit_amount).toFixed(2)  : "",
                          parseFloat(tx.credit_amount) > 0 ? parseFloat(tx.credit_amount).toFixed(2) : "",
                          `${Math.abs(running).toFixed(2)} ${running >= 0 ? "Dr" : "Cr"}`];
                      });
                      exportExcel(`Ledger - ${data.ledger?.ledger_name}`, cols, rows);
                    }} className="btn btn-success btn-sm">
                      <i className="fa fa-file-excel-o me-1" /> Excel
                    </a>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-sm">
                    <thead style={{ backgroundColor: "#2d4ac6", color: "#fff" }}>
                      <tr>
                        <th>Date</th>
                        <th>Voucher No</th>
                        <th>Type</th>
                        <th>Narration</th>
                        <th className="text-end">Debit</th>
                        <th className="text-end">Credit</th>
                        <th className="text-end">Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="table-light">
                        <td colSpan={6}><strong>Opening Balance</strong></td>
                        <td className="text-end"><strong>{data.opening_balance.toFixed(2)} {data.opening_type}</strong></td>
                      </tr>
                      {data.transactions?.map((tx, i) => {
                        runningBalance += (parseFloat(tx.debit_amount) || 0) - (parseFloat(tx.credit_amount) || 0);
                        return (
                          <tr key={i}>
                            <td>{tx.voucher_date}</td>
                            <td>{tx.voucher_no}</td>
                            <td>{tx.voucher_type}</td>
                            <td>{tx.narration}</td>
                            <td className="text-end">{parseFloat(tx.debit_amount) > 0 ? parseFloat(tx.debit_amount).toFixed(2) : ""}</td>
                            <td className="text-end">{parseFloat(tx.credit_amount) > 0 ? parseFloat(tx.credit_amount).toFixed(2) : ""}</td>
                            <td className="text-end">{Math.abs(runningBalance).toFixed(2)} {runningBalance >= 0 ? "Dr" : "Cr"}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr className="fw-bold table-light">
                        <td colSpan={4}>Total</td>
                        <td className="text-end">{data.total_debit?.toFixed(2)}</td>
                        <td className="text-end">{data.total_credit?.toFixed(2)}</td>
                        <td className="text-end text-primary">{data.closing_balance?.toFixed(2)} {data.closing_type}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
}
